
import React from 'react';
import { Box } from 'grommet';

import Link from '../common/Link';

const InfoPanelTrat = ({object}) => {
    return (
        <Box>
            <Link link={`/trat/${object['id']}`} title="Zobrazit biotické mapování viniční tratě" />
        </Box>
    );
}

export default InfoPanelTrat;
